/* eslint-disable */
import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  MenuItem,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';
import { connect } from 'react-redux';
import * as actions from '../actions/admin.action';
import * as PlantAction from '../actions/plant.action';
import * as PantryAction from '../actions/pantry.action';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { AdminListToolbar, AdminListHead, AdminMoreMenu } from '../components/_dashboard/admin';
//
// import AdminList from '../_mocks_/admin';
import { server } from '../constants';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'admin_username', label: 'Username', alignRight: false },
  // { id: 'admin_password', label: 'Password', alignRight: false },
  { id: 'admin_name', label: 'ชื่อ-สกุล', alignRight: false },
  { id: 'admin_tel', label: 'เบอร์โทร', alignRight: false },
  { id: 'admin_permission', label: 'ระดับสิทธิ์', alignRight: false },
  { id: 'plant_no', label: 'พื้นที่', alignRight: false },
  { id: 'pantry_no', label: 'ตึก', alignRight: false },
  { id: 'status', label: 'สถานะ', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, plant, pantry) {
  if (Array.isArray(array)) {
    let dataFilter = [...array];

    if (query || plant || pantry) {
      dataFilter = filter(
        dataFilter,
        (_admin) =>
          _admin.admin_username.toLowerCase().indexOf(query.toLowerCase()) !== -1 &&
          (_admin.plant_no.toLowerCase() == plant.toLowerCase() ||
            plant == '' ||
            _admin.plant_no == '' ||
            plant == '%') &&
          (_admin.pantry_no.toLowerCase() == pantry.toLowerCase() ||
            pantry == '' ||
            _admin.pantry_no == '' ||
            pantry == '%')
      );
    }

    const stabilizedThis = dataFilter.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  } else return [];
}

export function Admin(props) {
  const location = useLocation();
  // const adminType = '/dashboard/admin' == location.pathname ? 'J' : 'G';
  const { type } = useParams();
  const [plantList, setPlantList] = useState(null);
  const [pantryList, setPantryList] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [plantfilterName, setPlantFilterName] = useState('');
  const [pantryfilterName, setPantryFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(localStorage.getItem(server.ROWS_PER_PAGE))
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filteredUsers.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    localStorage.setItem(server.ROWS_PER_PAGE, event.target.value);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleplantFilterByName = (event) => {
    setPlantFilterName(event.target.value);
    setPantryFilterName('');
  };

  const handlepantryFilterByName = (event) => {
    setPantryFilterName(event.target.value);
  };

  useEffect(() => {
    //fetchData();
    props.getPlants();
  }, []);

  useEffect(() => {
    props.getPantryByPlantNo(plantfilterName);
  }, [plantfilterName]);

  // async function fetchData() {
  //   await props.getAdmins();
  // }
  useEffect(() => {
    const { result } = props.pantryReducer;
    if (result && plantfilterName != '') setPantryList(result);
  }, [props.pantryReducer]);

  useEffect(() => {
    const { result } = props.plantReducer;
    // console.log(result);
    if (result) setPlantList(result);
  }, [props.plantReducer]);

  useEffect(() => {
    //fetchData();
    props.getAdminByType(type);
  }, [type]);

  useEffect(() => {
    const { result } = props.adminReducer;
    if (result) setAdminList(result);
  }, [props.adminReducer]);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - adminList.length) : 0;

  const filteredUsers =
    adminList != null
      ? applySortFilter(
          adminList,
          getComparator(order, orderBy),
          filterName,
          plantfilterName,
          pantryfilterName
        )
      : [];

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Admin | JConnect">
      <Container maxWidth="false">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            กำหนดผู้ใช้งาน
          </Typography>
          <Button
            variant="contained"
            component={RouterLink}
            to={`/dashboard/adminproduct/${type}`}
            startIcon={<Icon icon={plusFill} />}
          >
            เพิ่มผู้ใช้งาน
          </Button>
        </Stack>

        <Card>
          {adminList && plantList && pantryList && (
            <>
              <AdminListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                plantfilterName={plantfilterName}
                plantonFilterName={handleplantFilterByName}
                pantryfilterName={pantryfilterName}
                pantryonFilterName={handlepantryFilterByName}
                plant={plantList}
                pantry={pantryList}
              />

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <AdminListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={filteredUsers.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {filteredUsers
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          const {
                            id,
                            admin_username,
                            admin_password,
                            admin_name,
                            admin_tel,
                            admin_permission,
                            plant_no,
                            pantry_no,
                            status
                          } = row;
                          const isItemSelected = selected.indexOf(id) !== -1;

                          return (
                            <TableRow
                              hover
                              key={id}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) => handleClick(event, id)}
                                />
                              </TableCell>
                              <TableCell align="left">{admin_username}</TableCell>
                              {/* <TableCell align="left">{admin_password}</TableCell> */}
                              <TableCell align="left">{admin_name}</TableCell>
                              <TableCell align="left">{admin_tel}</TableCell>
                              <TableCell align="left">{admin_permission}</TableCell>
                              <TableCell align="left">{plant_no}</TableCell>
                              <TableCell align="left">{pantry_no}</TableCell>
                              <TableCell align="left">
                                {status == 'A' ? 'ใช้งาน' : 'ไม่ใช้งาน'}
                              </TableCell>

                              <TableCell align="right">
                                <AdminMoreMenu props={props} type={type} id={id} />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUsers.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
        </Card>
      </Container>
    </Page>
  );
}

const mapStateToProps = ({ adminReducer, pantryReducer, plantReducer }) => ({
  adminReducer,
  pantryReducer,
  plantReducer
});

const mapDispatchToProps = {
  ...actions,
  ...PlantAction,
  ...PantryAction
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
